import { createTelegramPlatform } from './telegram-platform.ts';
import type { Platform } from './types.ts';

let active: Platform | undefined;

// The single selection point. Telegram is the only surface today; another
// shell installs its own with setPlatform before the app renders.
export const getPlatform = (): Platform => {
  active ??= createTelegramPlatform();
  return active;
};

export const setPlatform = (platform: Platform): void => {
  active = platform;
};
